import { render, staticRenderFns } from "./explore-study-sessions.vue?vue&type=template&id=8a2f247e&scoped=true&"
import script from "./explore-study-sessions.vue?vue&type=script&lang=ts&"
export * from "./explore-study-sessions.vue?vue&type=script&lang=ts&"
import style0 from "./explore-study-sessions.vue?vue&type=style&index=0&id=8a2f247e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a2f247e",
  null
  
)

export default component.exports